module.exports = __webpack_public_path__ + "img/titleTwo1.361fd9da.png";